import React, { useEffect, useState } from "react";
import { UnoStoreHooks, UiComponents } from "@simulanisindia/ui";
import InfiniteScroll from "react-infinite-scroll-component";
import { GROUP_LIST } from "../../../apiclient/apiEndpoints";
import apiclient from "../../../apiclient";
import { GROUP_LIMIT } from "../../../constant/constant";
import NoDataFound from "../../../NoDataFound";
import { useNavigate } from "react-router-dom";
import { div } from "three/tsl";
import PlaceholderCard from "../../../components/skeleton/PlaceholderCard";

const { useUnoSelector } = UnoStoreHooks;
const { GroupUserCard, GridView } = UiComponents;

const GroupsTab = ({ UUID, querySearch = null, selectedFilter=[] }) => {
  const configData = useUnoSelector((state) => state.config);
  const UNO_URL = configData?.config?.UNO_URL;
  const [groupList, setGroupList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const limit = GROUP_LIMIT;

  const fetchGroups = async (loadPage = page) => {
    try {
      const params = { page: loadPage, limit };
      if (querySearch) params.search = querySearch;
      if (selectedFilter?.length) {
        const roleIds = selectedFilter?.filter((e) => e.type == "role")?.map((e) => e.value) || [];
        const status = selectedFilter?.filter((e) => e.type == "status")?.map((e) => e.key) || [];
        if (roleIds?.length) params.roleIds = roleIds;
        if (status?.length) params.status = status;
      }

      const groupData = await apiclient.get(`${UNO_URL}${GROUP_LIST}/${UUID}`, { params });

      if (groupData?.length < limit) setHasMore(false);
      else setHasMore(true);

      const formattedData = groupData?.map((ele) => ({
        Name: ele.name,
        editButtonEnable: false,
        cardTypeUser: false,
        Image: ele.avatar,
        groupUsers: String(ele?.users),
        subGroup: String(ele?.groups),
        onClick: () => navigate(`/dashboard/${ele?.uuid}`),
      }));

      setGroupList((prev) => (loadPage === 1 ? formattedData : [...prev, ...formattedData]));
    } catch (error) {
      console.error("error in fetching from UNO", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMoreGroups = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchGroups(nextPage);
  };

  useEffect(() => {
    setPage(1);
    fetchGroups(1);
  }, [UUID, querySearch, selectedFilter]);

  return (
    <>
      {loading ? (
        <GridView>
          <PlaceholderCard circle count={4} />
        </GridView>
      ) : groupList.length > 0 ? (
        <div id="scrollableDiv" className="dashboardContent">
          <InfiniteScroll
            scrollableTarget="scrollableDiv"
            scrollThreshold={0.5}
            dataLength={groupList?.length}
            next={fetchMoreGroups}
            hasMore={hasMore}
          >
            <div className="groups-tab">
              <GridView>
                {groupList?.map((user, index) => (
                  <GroupUserCard key={index} {...user} />
                ))}
                {hasMore && <PlaceholderCard circle={true} count={4} />}
              </GridView>
            </div>
          </InfiniteScroll>
        </div>
      ) : (
        <NoDataFound headText="No Group Found" />
      )}
    </>
  );
};

export default GroupsTab;
